export enum DELIVERY_TIME_TYPE_ENUM {
  REGULAR = 'REGULAR',
  SCHEDULED = 'SCHEDULED',
  EXPRESS = 'EXPRESS',
  STORE_PICKUP = 'STORE_PICKUP',
}

export const DELIVERY_TIME_TYPE_COLOR = {
  [DELIVERY_TIME_TYPE_ENUM.SCHEDULED]: 'secondary.main',
  [DELIVERY_TIME_TYPE_ENUM.EXPRESS]: '#37AEFF',
  [DELIVERY_TIME_TYPE_ENUM.REGULAR]: 'primary.main',
  [DELIVERY_TIME_TYPE_ENUM.STORE_PICKUP]: 'primary.main',
};

export enum SHIPPING_TYPE_ENUM {
  HOME_DELIVERY = 'HOME_DELIVERY',
  STORE_PICKUP = 'STORE_PICKUP',
  ON_DEMAND = 'ON_DEMAND',
  STANDARD = 'STANDARD',
  EXPRESS = 'EXPRESS',
}

export const SHIPPING_TYPE_COLOR = {
  [SHIPPING_TYPE_ENUM.STORE_PICKUP]: 'warning.main',
  [SHIPPING_TYPE_ENUM.EXPRESS]: 'info.main',
  [SHIPPING_TYPE_ENUM.STANDARD]: 'primary.main',
  [SHIPPING_TYPE_ENUM.HOME_DELIVERY]: 'success.main',
  [SHIPPING_TYPE_ENUM.ON_DEMAND]: 'error.main',
};

export enum DELIVERY_MAX_TIME_ENUM {
  LATE = 'LATE',
  TIME = 'TIME',
  RISK = 'RISK',
  SEVERE = 'SEVERE',
  CRITICS = 'CRITICS',
}

export enum DISCOUNT_OFFER_TYPE {
  OFFER = 'OFFER',
  COUPON = 'COUPON',
}

export enum ORDER_TYPE_ENUM {
  PAID_ORDER = 'PAID_ORDER',
  PRE_ORDER = 'PRE_ORDER',
  SUB_ORDER = 'SUB_ORDER',
}

export enum DELIVERY_STATUS_ENUM {
  ON_TIME = 'ON_TIME',
  AT_RISK = 'AT_RISK',
  DELAYED = 'DELAYED',
  SEVERELY_DELAYED = 'SEVERELY_DELAYED',
}

export enum ORDER_REFERENCE_TYPE {
  ORDER = 'ORDER',
  SUB_ORDER = 'SUB_ORDER',
}
